import { render, staticRenderFns } from "./_page.vue?vue&type=template&id=bb3b31bc&scoped=true&"
import script from "./_page.vue?vue&type=script&lang=js&"
export * from "./_page.vue?vue&type=script&lang=js&"
import style0 from "./_page.vue?vue&type=style&index=0&id=bb3b31bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3b31bc",
  null
  
)

export default component.exports